/**
 * Reglas de negocio sobre quien puede hacer que. Funciones puras: no importan
 * React ni imagenes, para poder probarlas y para que exista un unico lugar
 * donde leer las reglas del modulo.
 *
 * Reglas vigentes:
 *   - Estudiante  -> solo ARIA, sin los campos de logistica.
 *   - Docente     -> ARIA y Libro a tu clase, ambos con logistica.
 *   - Administrador -> los dos tipos, con logistica.
 *   - Nadie radica ni edita a nombre de otra persona.
 */
import {
  PERFIL_ADMIN,
  PERFIL_DOCENTE,
  PERFILES_ESTUDIANTE,
} from "../../bienestar_estudiantil/helper";
import {
  ESTADO_ENTREGADA,
  ESTADO_SOLICITADA,
  ESTADOS_CERRADOS,
  TIPO_ARIA,
  TIPO_LIBROS,
} from "../constants";

const PERFILES_POR_TIPO = {
  [TIPO_LIBROS]: [PERFIL_ADMIN, PERFIL_DOCENTE],
  [TIPO_ARIA]: [PERFIL_ADMIN, PERFIL_DOCENTE, ...PERFILES_ESTUDIANTE],
};

export const perfilDe = (usuario) => usuario?.perfil?.codigo ?? null;

export const esAdministrador = (perfil) => perfil === PERFIL_ADMIN;

export const esDocente = (perfil) => perfil === PERFIL_DOCENTE;

export const esEstudiante = (perfil) => PERFILES_ESTUDIANTE.includes(perfil);

export const puedeSolicitar = (perfil, tipo) =>
  Boolean(perfil) && (PERFILES_POR_TIPO[tipo] ?? []).includes(perfil);
export const tiposDisponibles = (perfil) =>
  Object.keys(PERFILES_POR_TIPO).filter((tipo) => puedeSolicitar(perfil, tipo));

/**
 * La logistica (fecha, celular, bloque, salon, horas) siempre aplica en Libro
 * a tu clase. En ARIA solo la diligencia quien reserva el espacio: el docente
 * y el administrador que radica por el.
 */
export const puedeVerLogistica = (perfil, tipo) =>
  tipo !== TIPO_ARIA || esDocente(perfil) || esAdministrador(perfil);

// Nadie radica solicitudes a nombre de otra persona: el solicitante es
// siempre quien esta en sesion.

/**
 * El estudiante queda inscrito en su propia solicitud: es uno de los
 * asistentes, no solo quien pide. El docente y el administrador piden para
 * otros. Es la misma regla que se_inscribe_en_su_solicitud en el backend,
 * que la aplica aunque la pantalla no lo envie.
 */
export const seInscribeEnSuSolicitud = (perfil) => esEstudiante(perfil);

/**
 * Una solicitud se edita solo mientras biblioteca no ha empezado a
 * gestionarla, y solo la edita quien la radico: ni el administrador corrige
 * por otro. El backend vuelve a comprobarlo antes de guardar.
 */
export const puedeEditar = (solicitud, usuario) =>
  solicitud?.estado_actual?.codigo === ESTADO_SOLICITADA &&
  Boolean(usuario?.identificacion) &&
  solicitud?.solicitante?.identificacion === usuario.identificacion;

/**
 * El solicitante cancela lo propio en cualquier momento mientras siga
 * abierta, no solo en Solicitada, salvo cuando ya se entrego (decidido el
 * 2026-10-14). Es puede_cancelar en el backend.
 */
const NO_CANCELABLES = [...ESTADOS_CERRADOS, ESTADO_ENTREGADA];

export const puedeCancelar = (solicitud, usuario) =>
  Boolean(solicitud?.estado_actual?.codigo) &&
  !NO_CANCELABLES.includes(solicitud.estado_actual.codigo) &&
  Boolean(usuario?.identificacion) &&
  solicitud?.solicitante?.identificacion === usuario.identificacion;
